import {
  BetSlipItem,
  BetSource,
  FobPropositionSelection,
  RacingBetType,
  ToteSelection,
} from '@mobi/betslip/types'
import { keys } from '@classic/Foundation/Analytics/AnalyticsDataLayer'
import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'
import { isRaceDetails } from '@mobi/betslip/helpers/typeGuards'
import { isMysteryDetails } from '@core/Data/Betting/selectionDetails'

export const trackAddToBetSlip = (addedItem: BetSlipItem | BetSlipItem[]) => {
  const isMultiSelection = Array.isArray(addedItem)

  if (isMultiSelection) {
    const item = addedItem[0]
    trackAddToBetSlipBase({ source: item.betSource, betType: 'multi' })
    return
  }

  const { selection, selectionDetails, betSource } = addedItem

  if (betSource && selection && selectionDetails) {
    const betType =
      (selection as ToteSelection).betType || (selection as FobPropositionSelection).type

    const race = isRaceDetails(selectionDetails)
      ? selectionDetails.races[0]
      : isMysteryDetails(selectionDetails)
        ? selectionDetails.race
        : null

    const { meetingCode: raceCode, meetingName } = race || {
      meetingName: null,
      meetingCode: null,
    }

    trackAddToBetSlipBase({ source: betSource, raceCode, meetingName, betType })
  }
}

export const trackBetSlipClear = (): void => trackEvent(keys.betslipCleared, {})

// =============
// Local Helpers
// =============

function trackAddToBetSlipBase(data: {
  betType: BetType
  source?: BetSource | null
  raceCode?: string | null
  meetingName?: string | null
}): void {
  trackEvent(keys.betslipBetAdded, { data })
}

// =====
// Types
// =====

type BetType = RacingBetType | 'multi'
